import { UserSelectionInput } from "@src/types.generated";
import { useMemo, useState } from "react";

type Props = {
  input?: UserSelectionInput;
  allowUserTypes: boolean;
};
type Return = {
  userSelectionInput: UserSelectionInput;
  setUserSelectionInput: (input: UserSelectionInput) => void;
};

const useUserSelectionInputState = (props: Props): Return => {
  const [localOverrides, setLocalOverrides] = useState<
    UserSelectionInput | undefined
  >();

  const adjustedInput = useMemo(() => {
    const userSelectionInput = localOverrides || props.input;

    const hasSelectedRoles =
      userSelectionInput?.roleIds && userSelectionInput?.roleIds.length > 0;
    const hasSelectedLocations =
      userSelectionInput?.locationIds &&
      userSelectionInput?.locationIds.length > 0;
    const hasSelectedLocationGroups =
      userSelectionInput?.locationGroupIds &&
      userSelectionInput?.locationGroupIds.length > 0;
    const hasSelectedRoleGroups =
      userSelectionInput?.roleGroupIds &&
      userSelectionInput?.roleGroupIds.length > 0;
    const selectAllRoles =
      !hasSelectedRoles &&
      !hasSelectedRoleGroups &&
      (hasSelectedLocations || hasSelectedLocationGroups);

    if (props.allowUserTypes) {
      return {
        allLocations: false,
        userIds: userSelectionInput?.userIds,
        locationGroupIds: userSelectionInput?.locationGroupIds,
        roleGroupIds: userSelectionInput?.roleGroupIds,
        locationIds: userSelectionInput?.locationIds,
        roleIds: userSelectionInput?.roleIds,
        allManagers: !!userSelectionInput?.allManagers,
        allAdmins: !!userSelectionInput?.allAdmins,
        allTrainees: !!userSelectionInput?.allTrainees,
        everyoneAtOrgOrBrand: userSelectionInput?.everyoneAtOrgOrBrand,
        daysAfterHire: userSelectionInput?.daysAfterHire,
      };
    }
    return {
      allLocations: false,
      userIds: userSelectionInput?.userIds,
      locationGroupIds: userSelectionInput?.locationGroupIds,
      roleGroupIds: userSelectionInput?.roleGroupIds,
      locationIds: userSelectionInput?.locationIds,
      roleIds: userSelectionInput?.roleIds,
      allManagers: !!selectAllRoles,
      allAdmins: !!selectAllRoles,
      allTrainees: !!selectAllRoles,
      everyoneAtOrgOrBrand: userSelectionInput?.everyoneAtOrgOrBrand,
      daysAfterHire: userSelectionInput?.daysAfterHire,
    };
  }, [props.allowUserTypes, props.input, localOverrides]);

  return useMemo(() => {
    return {
      userSelectionInput: adjustedInput,
      setUserSelectionInput: setLocalOverrides,
    };
  }, [adjustedInput]);
};

export default useUserSelectionInputState;
